import { render, staticRenderFns } from "./ReglementNew.vue?vue&type=template&id=327fc584&"
import script from "./ReglementNew.vue?vue&type=script&lang=js&"
export * from "./ReglementNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327fc584')) {
      api.createRecord('327fc584', component.options)
    } else {
      api.reload('327fc584', component.options)
    }
    module.hot.accept("./ReglementNew.vue?vue&type=template&id=327fc584&", function () {
      api.rerender('327fc584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/reglements/ReglementNew.vue"
export default component.exports